"use client";

import Link from "next/link";
import { LuWebcam, LuYoutube } from "react-icons/lu";
import { FaExternalLinkAlt } from "react-icons/fa";
import { TbBrandZoom } from "react-icons/tb";
import { SiGooglemeet } from "react-icons/si";
import { GetEventFromSlug } from "../actions";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "~/components/v3/shadcn/Tooltip";
import { CustomizableLayout } from "~/types/CustomizableLayout";
import { cn } from "~/utils/fontsConfig";

const VirtualEventLink = ({
    event,
    customization,
}: {
    event: GetEventFromSlug;
    customization?: CustomizableLayout & {
        infobox: {
            bg?: string;
            content?: string;
            label?: string;
        };
    };
}) => {
    if (!event.virtualEventUrl) return null;

    const link = event.virtualEventUrl.includes("https")
        ? event.virtualEventUrl
        : `https://${event.virtualEventUrl}`;

    const icon = event.virtualEventUrl.includes("zoom") ? (
        <TbBrandZoom className="h-5 w-5 text-white" />
    ) : event.virtualEventUrl.includes("youtube") ? (
        <LuYoutube className="h-5 w-5 text-white" />
    ) : event.virtualEventUrl.includes("meet") ? (
        <SiGooglemeet className="h-5 w-5 text-white" />
    ) : (
        <LuWebcam className="h-5 w-5 text-white" />
    );

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger>
                    <div className="grid grid-cols-[48px_1fr_96px] items-center gap-4">
                        <Link
                            href={link}
                            target="_blank"
                            className={cn(
                                "flex h-12 w-12 items-center justify-center rounded-lg bg-v3-N-500",
                                customization?.infobox?.bg,
                            )}
                        >
                            {icon}
                        </Link>
                        <Link
                            href={link}
                            target="_blank"
                            className={cn(
                                "relative flex h-12 w-48 items-center justify-start rounded-lg bg-v3-N-500 px-3",
                                customization?.infobox?.bg,
                            )}
                        >
                            Go to event meeting
                            <FaExternalLinkAlt
                                className={cn(
                                    "absolute right-1 top-1 z-10 text-v3-N-300",
                                    customization?.infobox?.content,
                                )}
                            />
                        </Link>
                    </div>
                </TooltipTrigger>
                <TooltipContent>
                    <p
                        className={cn(
                            "w-[200px] text-sm",
                            customization?.descriptionClassName,
                        )}
                    >
                        The URL to join the event meeting is only visible to
                        managers, hosts and attendees.
                    </p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default VirtualEventLink;
